import React, { useMemo, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { TabSwitcher as TabSwitcherComponent } from '@ann/web-components';
import { SwitcherContainer, TabSwitcherContainerLeft } from './TabSwitcher.styled';
import { PLAYGROUND_TABS } from '../../constants/playgroundConstants';

const TabSwitcher = ({ onTabChange }) => {
  const location = useLocation();

  // Determinar tab activo basado en la URL
  const activeTab = useMemo(() => {
    const pathname = location.pathname;
    if (pathname.includes('/create')) {
      return PLAYGROUND_TABS.CREATE;
    } else if (pathname.includes('/knowledge')) {
      return PLAYGROUND_TABS.KNOWLEDGE;
    } else if (pathname.includes('/instructions')) {
      return PLAYGROUND_TABS.INSTRUCTIONS;
    } else if (pathname.includes('/tools')) {
      return PLAYGROUND_TABS.TOOLS;
    } else {
      return PLAYGROUND_TABS.CONFIGURATION;
    }
  }, [location.pathname]);

  const handleTabChange = useCallback((tabId) => {
    onTabChange?.(tabId);
  }, [onTabChange]);

  return (
    <SwitcherContainer>
      <TabSwitcherContainerLeft>
        <TabSwitcherComponent
          key={activeTab}
          defaultSelectedId={activeTab}
          size="medium"
          onChange={handleTabChange}
        >
          <TabSwitcherComponent.Button id={PLAYGROUND_TABS.CREATE} label="Create" />
          <TabSwitcherComponent.Button id={PLAYGROUND_TABS.CONFIGURATION} label="Configuration" />
          <TabSwitcherComponent.Button id={PLAYGROUND_TABS.KNOWLEDGE} label="Knowledge" />
          <TabSwitcherComponent.Button id={PLAYGROUND_TABS.INSTRUCTIONS} label="Instructions" />
          <TabSwitcherComponent.Button id={PLAYGROUND_TABS.TOOLS} label="Tools" />
        </TabSwitcherComponent>
      </TabSwitcherContainerLeft>
    </SwitcherContainer>
  );
};

export default TabSwitcher;

